import * as React from "react";
import Svg, { SvgProps, Path } from "react-native-svg";
const SvgComponent = (props: SvgProps) => (
  <Svg width={32} height={32} fill="none" {...props}>
    <Path
      fill="#000"
      d="M13.2 26.564h5.549v-1.497l.661-.236c1.704-.54 3.15-1.39 4.338-2.549 1.189-1.159 2.006-2.37 2.452-3.636H5.8c.444 1.264 1.249 2.479 2.413 3.644 1.164 1.165 2.599 2.012 4.305 2.54l.682.232v1.502Zm-1.23 1.23v-1.86c-2.081-.65-3.819-1.766-5.213-3.35C5.363 21 4.512 19.277 4.205 17.415h2.667V6.477l20.923-2.289v1.14L13.938 6.845v2.863h13.857v1.118H13.938v6.59h13.857c-.27 1.86-1.12 3.584-2.55 5.168-1.43 1.584-3.185 2.7-5.266 3.35v1.86h-8.01ZM10.953 9.709h1.866v-2.74l-1.866.192v2.548Zm-2.964 0h1.866V7.27l-1.866.22v2.217Zm2.964 7.707h1.866v-6.59h-1.866v6.59Zm-2.964 0h1.866v-6.59H7.99v6.59Z"
    />
  </Svg>
);
export default SvgComponent;
